<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-show="!loading">
      <div class="vx-row md:w-full lg:w-full sm:w-full mb-2">
        <div class="vx-col sm:w-full md:w-1/2">
          <router-link to="/bill-management" class="vx-row">
            <h4 class="routepath">
              <span class="primary">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" class="shift-2"
              /></span>
              <span class="secondary">{{ $t("billManagement.label.trialBilling") }}</span>
            </h4>
          </router-link>
        </div>
        <div class="vx-card pl-6 pr-6 mt-3" style="min-height: 643px">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-1/2 mt-4">
              <div class="grid grid-cols-4">
                <h4 class="font-semibold">{{ $t("billManagement.label.BillCycle") }}:</h4>
                <span>{{ data && data.id }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-1/5 mt-4">
              <div class="radio-group flex flex-wrap">
                <div class="radio-option">
                  <vs-radio
                    v-model="type"
                    vs-value="ChargingQueryAll"
                    class="mr-4"
                    vs-name="creditRadios"
                  >
                    {{ $t("billManagement.label.all") }}
                  </vs-radio>
                </div>
                <div class="radio-option">
                  <vs-radio
                    v-model="type"
                    vs-value="ChargingQueryCustom"
                    class="mr-4"
                    vs-name="creditRadios"
                  >
                    {{ $t("billManagement.label.upload") }}
                  </vs-radio>
                </div>
              </div>
            </div>
            <div
              class="vx-col sm:w-full md:w-1/2 mt-4"
              v-if="type === 'ChargingQueryCustom'"
            >
              <pick-file @fileUpdate="uploadOnChange" />
            </div>
          </div>
          <div v-if="type">
            <div class="flex justify-center">
              <vs-button
                color="primary"
                type="border"
                class="sub_button mb-2 footerButton-cancel"
                @click="cancelBtn"
                >{{ $t("admin.label.Cancel") }}</vs-button
              >
              <vs-button
                color="primary"
                class="sub_button2 mb-2 footerButton-next"
                @click="submitTrialBilling()"
              >
                {{ $t("admin.label.Submit") }}</vs-button
              >
            </div>
          </div>
          <div v-if="show" class="mt-5">
            <stepProgressIndicator :orderDetailsData="orderDetailsData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import stepProgressIndicator from "../../components/stepProgressIndicator.vue";
import PickFile from "@/components/PickFile.vue";
import moment from "moment";
import { setHeader, removeHeader } from "@/http";
import { AtomSpinner } from "epic-spinners";
import _ from "lodash";
export default {
  components: {
    PickFile,
    stepProgressIndicator,
    AtomSpinner,
  },
  data() {
    return {
      show: false,
      loading: false,
      orderDetailsData: [
        {
          label: "Customer Upload",
          status: "In Progress",
        },
        {
          label: "Trial Charge",
          status: "Not Started",
        },
        {
          label: "Trial Invoice",
          status: "Not Started",
        },
      ],
      data: "",
      type: "",
      bulkUploads: {
        status: "Upload ClientList",
        description: "Test",
        file: null,
      },
    };
  },
  methods: {
    uploadOnChange(file) {
      this.bulkUploads.file = file ? file : null;
    },
    async submitTrialBilling() {
      this.show = true;
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      try {
        if (this.type === "ChargingQueryCustom") {
          this.orderDetailsData[0].status = "In Progress";
          await this.addUploadFile();
          this.orderDetailsData[0].status = "Complete";
          await delay(4000);
        } else {
          this.orderDetailsData[0].status = "Complete";
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Customer uploaded successfully!",
            type: "success",
          });
          await delay(4000);
        }
      } catch (error) {
        this.orderDetailsData[0].status = "Failed";
        return;
      }
      try {
        this.orderDetailsData[1].status = "In Progress";
        await this.updateJobParam(45);
        await this.updateJobParam(46);
        this.orderDetailsData[1].status = "Complete";
        await delay(4000);
      } catch (error) {
        console.error("Trial Billing Failed:", error);
        this.orderDetailsData[1].status = "Failed";
        return;
      }
      try {
        this.orderDetailsData[2].status = "In Progress";
        await this.executeTrialInvoice(45);
        await this.executeTrialInvoice(46);
        this.orderDetailsData[2].status = "Complete";
        await delay(2000);
        this.$router.push("/bill-management");
      } catch (error) {
        console.error("Trial Invoice Failed:", error);
        this.orderDetailsData[2].status = "Failed";
      }
    },
    async updateJobParam(id) {
      const data = await this.$store.dispatch("admin/getJobParameters", id);
      this.jobparam = data.data || [];
      const payload = {
        jobParameters: this.jobparam.NGBPramList,
      };
      for (let item of payload.jobParameters) {
        if (item.paramName === "reportName") {
          item.paramValue = this.type;
        }
        if (item.paramName === "processDate") {
          item.paramValue = moment(
            (this.data && this.data.data && this.data.data.nextBillingDate) || new Date()
          ).format("DD MMMM YYYY");
        }
        if (item.paramName === "billCycle" || item.paramName === "billDayOfMonth") {
          item.paramValue = this.data && this.data.data && this.data.data.id;
        }
      }
      try {
        await this.$store.dispatch("admin/updateJobParameterAction", {
          id: id,
          data: payload,
        });
        this.jobsParameterPopup = false;
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something went wrong",
          type: "warning",
        });
      }
    },
    createFormData(object) {
      let formData = new FormData();
      _.forEach(object, (value, key) => {
        formData.append(key, value);
      });
      return formData;
    },
    async addUploadFile() {
      try {
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("file", this.bulkUploads.file);
        formData.append("status", this.bulkUploads.status);
        formData.append("description", this.bulkUploads.description);
        const data = await this.$store.dispatch(
          "admin/addBulkUploadsAction",
          formData,
          this.createFormData(this.bulkUploads)
        );
        await this.$store.dispatch("admin/processFile", data.data);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Document Uploaded successfully!",
          type: "success",
        });
        removeHeader("Content-Type");
      } catch (e) {
        console.log(e);
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    cancelBtn() {
      this.$router.push("/bill-management");
    },
    async executeTrialInvoice(id) {
      await this.$store.dispatch("admin/executeJobsAction", id);
      this.$swal({
        title: "Congratulations!",
        icon: "success",
        text: "Your Trial Bill has been Successfully Generated...",
        type: "success",
      });
    },
  },
  mounted() {
    this.data = this.$route.params;
  },
};
</script>
<style>
.sub_button {
  margin-right: 100px;
}
.sub_button2 {
  margin-right: 125px;
}
</style>
